import { collection, doc, getDocs, orderBy, query, setDoc } from "firebase/firestore";
import { isEmpty } from "lodash";
const { db, auth } = require("../firebase");

export const createProperty = async (data, mediaURLs) => {
  const { rooms, ...rest } = data;
  const propertyRef = doc(db, `users/${auth.currentUser.uid}/properties`, data?.propertyName);
  if (mediaURLs?.length > 0) {
    await setDoc(propertyRef, { ...rest, media: mediaURLs });
    const propertyName = data?.propertyName;
    await createRooms({ propertyName, rooms });
  } else {
    await setDoc(propertyRef, rest);
    const propertyName = data?.propertyName;
    await createRooms({ propertyName, rooms });
  }
  return "success";
};

export const createRooms = async (data) => {
  const { rooms } = data;
  if (!isEmpty(rooms)) {
    rooms.forEach(async (room) => {
      const roomRef = doc(db, `users/${auth.currentUser.uid}/properties/${data?.propertyName}/rooms`, room?.room);
      await setDoc(roomRef, { room: room?.room, roomNickname: room?.roomNickname, roomNumber: room?.roomNumber, propertyName: data?.propertyName });
    });
  }
  return "success";
};

export const getProperties = async () => {
  const propertiesRef = query(collection(db, `users/${auth.currentUser.uid}/properties`));
  const querySnapshot = await getDocs(propertiesRef);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};

export const getRooms = async (name) => {
  const roomsRef = query(collection(db, `users/${auth.currentUser.uid}/properties/${name}/rooms`));
  const querySnapshot = await getDocs(roomsRef);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};

export const getContents = async (name, room) => {
  const contentsRef = query(collection(db, `users/${auth.currentUser.uid}/properties/${name}/rooms/${room}/contents`));
  const querySnapshot = await getDocs(contentsRef);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};

export const addContent = async (data, mediaURLs) => {
  const roomRef = doc(db, `users/${auth.currentUser.uid}/properties/${data?.propertyName}/rooms/${data?.room}/contents`, data?.itemName);
  if (!isEmpty(mediaURLs)) {
    await setDoc(roomRef, { ...data, media: mediaURLs });
  } else {
    await setDoc(roomRef, data);
  }
  return "success";
};

export const addClaim = async (data, mediaURLs) => {
  const claimRef = doc(db, `users/${auth.currentUser.uid}/claims`, data?.claimName);
  if (!isEmpty(mediaURLs)) {
    await setDoc(claimRef, { ...data, media: mediaURLs });
  } else {
    await setDoc(claimRef, data);
  }
  return "success";
};

export const addClaimNote = async (data) => {
  // const noteRef = doc(collection(db, `users/${auth.currentUser.uid}/claims/${data?.claimNumber}/notes`));
  
  const noteRef = doc(collection(db, `users/${auth.currentUser.uid}/claims/${data?.claimName}/notes`));
  await setDoc(noteRef, data);
  return "success";
};

export const getClaimNotes = async (claimName) => {
  const notesRef = query(collection(db, `users/${auth.currentUser.uid}/claims/${claimName}/notes`), orderBy("createdAt"));
  const querySnapshot = await getDocs(notesRef);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};
